import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.css']
})
export class WarningDialogComponent {
  constructor(public modalRef: BsModalRef) {}

  @Input() body = "Are you sure you want to perform this action?";
 
  @Output()onConfirmClicked = new EventEmitter();
 
  onConfirm: any = () => {};

  close() {
    this.modalRef.hide();
  }

 
}
